// extracted by mini-css-extract-plugin
export default {"slider":"ImageSlider_slider__j6sqa","image":"ImageSlider_image__Hn-FG","show":"ImageSlider_show__XlPqj"};